// extracted by mini-css-extract-plugin
export default {"postList":"BlogPostList_postList__Kes1a"};